import React, { ReactElement, useEffect } from "react";
import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { ErrorResponse } from "@apollo/client/link/error";
import useRouting from "../../../contexts/Routing";

import { LoadingIcon } from "../../../components/loading/Loading";
import { GetCurrentPortalDocument } from "../../../__generated__/api";
import useLogging from "../../../contexts/logging/LoggingContext";

const TOP_LEVEL_DOMAIN = process.env.REACT_APP_TOP_LEVEL_DOMAIN;
const TOP_LEVEL_PATH = process.env.REACT_APP_TOP_LEVEL_DOMAIN_PATH as string;

export default function WaitForDomain() : ReactElement | null {
    const { getSearchParams, Paths } = useRouting();
    const { domain, redirect } = getSearchParams(Paths.WAIT_FOR_DOMAIN);
    const logger = useLogging();

    useEffect(() => {
        const fullDomain = `https://${domain}.${TOP_LEVEL_DOMAIN}`;
        const apiDomain = new URL(TOP_LEVEL_PATH, fullDomain);

        if (!redirect || !redirect.startsWith(`${fullDomain}/`)) {
            logger.error({ redirect }, "Invalid redirect");
            return;
        }

        const client = new ApolloClient({
            link: createHttpLink({
                uri: apiDomain.toString(),
                credentials: "include",
            }),
            cache: new InMemoryCache(),
        });

        setInterval(async () => {
            try {
                await client.query({
                    query: GetCurrentPortalDocument,
                });
            } catch (err) {
                const { networkError } = err as ErrorResponse;
                if (networkError) {
                    return;
                }
            }
            window.location.href = redirect;
        }, 1000);
    }, []);

    return (

        <div className="full-page">
            <div className="centered-container centered-container-lg pt-5">

                <div className="d-flex flex-row justify-items-between align-items-center w-100">
                    <div className="col">
                        <h4>👋 Welcome to Foqal</h4>
                        <p>
                            Welcome to the Foqal ticketing system. We are currently setting up your environment.
                        </p>
                        <p className="text-primary fw-bolder mb-4">
                            Don&apos;t move a muscle, this page will automatically redirect in a few seconds...
                        </p>
                    </div>

                    <LoadingIcon className="col-1" />
                </div>

            </div>
        </div>

    );
}
